import React from 'react';
import { IndexCoordinatorDelegate } from "../IndexCoordinator";

import ProtectedRoute from '../../Components/ProtectedRoute';
import { StreetViewViewController, StreetViewViewControllerDelegate } from '../../Screen/StreetView/StreetViewController';
import { TableGenericViewModel } from "../../Screen/TableGeneric/TableGenericViewModel";
import { StreetViewViewModel } from '../../Screen/StreetView/StreetViewViewModel';

export class StreetViewCoordinator implements IndexCoordinatorDelegate, StreetViewViewControllerDelegate {

    getRoute(): JSX.Element[] {
        return [
            this.routeTable(),
        ]
    }

    private routeTable(): JSX.Element {
        var viewModel = new StreetViewViewModel()
        return (<ProtectedRoute requiredPermissions={['config.street_view.importar']} path="/:base/config/street-view" exact={true} component={(props: any) => {
            return (<StreetViewViewController
                navigation={props}
                viewModel={viewModel}
                delegate={this}
            />)
        }} />)
    }

    tapDimiss(navigation: any): void {
        navigation.history.goBack();
    }


}